import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useVerifyEmailMutation } from "../../features/api/authApiSlice";
import "./auth.scss";

export default function VerifyEmail() {
  const { token } = useParams();

  const [verifyEmail, { isLoading, isSuccess, isError, error, data }] =
    useVerifyEmailMutation();

  useEffect(() => {
    if (token) {
      verifyEmail(token);
    }
  }, [token, verifyEmail]);

  return (
    <main className="auth-page">
      <section className="auth-card auth-card--center">
        {isLoading && (
          <>
            <h1>Verifying Email...</h1>
            <p>Please wait while we confirm your Mini Miles account.</p>
          </>
        )}

        {isSuccess && (
          <>
            <h1>Email Verified</h1>
            <p>
              {data?.message || "Your email has been verified successfully."}
            </p>

            <Link className="auth-button-link" to="/login">
              Continue to Login
            </Link>
          </>
        )}

        {isError && (
          <>
            <h1>Verification Failed</h1>
            <p>
              {error?.data?.message ||
                "This verification link is invalid or expired."}
            </p>

            <Link className="auth-button-link" to="/register">
              Create New Account
            </Link>
          </>
        )}
      </section>
    </main>
  );
}
